import { Injectable } from '@angular/core';
import { BaseProvider } from '../BaseProvider';
import { Router, NavigationExtras } from '@angular/router';
import { Http } from '@angular/http';
import { GlobalService } from "../../_global/global.service";
import { creditModel } from '../../_models/Refer&Earn/ReferEarnModel';

@Injectable()
export class referEarnService extends BaseProvider {
    resource = 'partnerCredits';
    referral = "partnerReferral";


    constructor(private http: Http, private router: Router, private _gs: GlobalService) {
        super(http);
    }
    getCredits() {
        return this.makeGetCall(this.resource);
    }
    getReferral() {
        return this.makeGetCall(this.referral);
    }
}


// WEBPACK FOOTER //
// ./src/app/_services/ReferEarn/referEarn.service.ts